<template>
  <div id="frame">
    <div class="header">
      <p class="cancelButton" @click="close"></p>
    </div>
    <div class="body">
      <img src="/static/compare/result_icon.png" alt="담당자 아이콘">
      <h1><b>담당자</b>가 <b style="color: #174be5">연락드리겠습니다.</b></h1>
    </div>
    <div class="footer">
      <div class="section">
        <div class="button" @click="goToBack">보험료 비교표 다시보기<img :src="'../static/Shape.png'" /></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$store.commit("elementModal/CLEAR_ITEMS");
    },
    goToBack() {
      const { query } = this.$parent.element;

      this.close();

      this.$router.push({
        name: 'lifeEstimate',
        query
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  #frame {
    background-color: white;
    width: 600px;

    .header {
      margin: 0 auto;
      padding: 50px;
      .cancelButton{
          width: 2rem;
          height: 2rem;
          background-image: url(/static/images/connection/close-white.png);
          background-size: 1rem;
          background-repeat: no-repeat;
          background-position: center;
          font-size: 16px;
          font-weight: 600;
          position: absolute;
          right: 20px;
          top: 2rem;
          cursor: pointer;
          background-color: #174de533;
          border-radius: 100%;
      }
    }

    .body {
      img {
        margin: 0 auto;
      }
      h1 {
        text-align: center;
        margin: $unit 0;
        font-size: 2*$unit;
      }
    }
    .footer {
      padding: 25px;
      .section {
        text-align: center;
        .button {
          height: 65px;
          width: 241px;
          background: #174de5;
          line-height: 65px;
          text-align: center;
          margin: 0 auto;
          color: white;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          &.disabled {
            cursor: not-allowed;
            background: #959595;
          }
          img {
            display: inline;
            margin-left: 30px;
            top: -3px;
          }
        }
      }
    }

    @include media-mobile {
      max-height: 780px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 11px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #174de5;
      }
      &::-webkit-scrollbar-track {
        background-color: #e7edfc;
      }
      .header {
        padding: 50px $unit $unit $unit;

        .head {
          margin-bottom: 1.5*$unit;
        }
      }
    }
  }
</style>